import {useCallback, useEffect, useState} from "react";

export const screenSizes = {
  mobile: 768,
  tablet: 1024,
  laptop: 1440
};

export type TBreakpoint = keyof typeof screenSizes;

export const useScreenSize = (breakpoint: TBreakpoint) => {

  const breakpointSize = screenSizes[breakpoint];
  const [screenSize, setScreenSize] = useState<boolean>(window.innerWidth <= breakpointSize);

  const handleWindowSizeChange = useCallback(() => {
    const currentScreenSize = window.innerWidth <= breakpointSize;
    setScreenSize(previousScreenSize => {
      if (currentScreenSize !== previousScreenSize) {
        return currentScreenSize;
      }
      return previousScreenSize;
    });
  }, [breakpointSize]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [handleWindowSizeChange]);

  return screenSize;
};